module.exports = __webpack_public_path__ + "img/user.0da1bcca.svg";